import { render, staticRenderFns } from "./LineBreakResolverExtra.vue?vue&type=template&id=cfab341c&"
import script from "./LineBreakResolverExtra.vue?vue&type=script&lang=js&"
export * from "./LineBreakResolverExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports